<template>
  <form class="posfinder-screen__form" @submit.prevent="startSearch" :class="{'is-open': openForm}">
    <div class="posfinder-screen__form-wrapper">
      <div class="posfinder-screen_mainheader">
        <p class="h2 margin_l form-titel">Finde jetzt dein Krumbach</p>
      </div>
      <div class="posfinder-screen__group">
        <div class="posfinder__form posfinder__form--finder">
          <input class="font_input" type="text" v-model="form.query" placeholder="Ort oder PLZ eingeben">
          <button v-if="form.query.length > 0" type="submit" @click.prevent="startSearch(false)">
            <img width="16" height="16" src="/wp-content/plugins/zrm-posfinder/_assets/graphics/posfinder/posfinder_chevron_right_blue.svg" alt="">
          </button>
          <button v-else type="submit" @click.prevent="startGeo">
            <img class="icon_pin" src="/wp-content/plugins/zrm-posfinder/_assets/graphics/posfinder/pos_finder_pin.svg" alt="">
          </button>
        </div>
        <div class="posfinder-screen__range">
          <input type="range" v-model="form.filter" :min="filter.min" :max="filter.max" :step="filter.steps"
                 @change="startSearch(false)">
          <span class="secondaryfont-regular">
                    {{ form.filter }} km
                    Umkreis
                </span>
        </div>
      </div>

      <Spinner v-if="!ready && loading" :loading="true" :inline="true"/>
      <template v-else>
        <div
            class="posfinder-screen__group posfinder-screen__group--grey"
            :class="{'is-hidden': !filterOpen}"
        >

          <div class="posfinder-screen__field">
            <SingleSelect
                id="category"
                :active="!form.category"
                v-model="form.category"
                :options="categoryList"
                :title="b => b.name"
                :name="'category'"
                @change="startSearch(true,'category')"
            >Wähle die Kategorie
            </SingleSelect>
          </div>

          <div class="posfinder-screen__field">
            <SingleSelect
                id="productGroup"
                :active="form.category && !form.productGroup"
                v-if="form.category && productGroupList.length"
                v-model="form.productGroup"
                :options="productGroupList"
                :title="b => b.name"
                :name="'product_group'"
                @change="startSearch(true,'product_group')"
            >Wähle die Sorte
            </SingleSelect>
          </div>

          <div class="posfinder-screen__field">
            <SingleSelect
                id="product"
                :active="form.productGroup && !form.product"
                v-if="form.productGroup && productList.length"
                v-model="form.product"
                :options="productList"
                :title="b => b.name"
                :name="'product'"
                @change="startSearch(true)"
            >Wähle das Gebinde
            </SingleSelect>
          </div>
<!--          <div class="posfinder-screen__field">
            <MultiSelect
                v-model="form.productGroup"
                :options="productGroupList"
                :title="b => b.name"
                @change="startSearch(true)"
            >Wähle die Sorte
            </MultiSelect>
          </div>-->

<!--          <div class="posfinder-screen__field">
            <MultiSelectProduct
                v-if="form.productGroups.length !== 0"
                :disabled="form.productGroups.length === 0"
                v-model="form.categories"
                :options="selectedProductGroupList"
                :title="b => b.name"
                @change="startSearch(true)"
            >Gebinde
            </MultiSelectProduct>
          </div>-->

<!--          <div class="posfinder-screen__field">
            <MultiSelect v-if="form.categories.length !== 0"
                         :disabled="form.categories.length === 0"
                         :forceClose="!openForm"
                         v-model="form.products"
                         :options="selectedCategoryList"
                         :title="p => p.name"
                         @change="startSearch(true)">
              Wähle dein Getränk
            </MultiSelect>
          </div>-->
        </div>
      </template>
    </div>
    <button
        class="posfinder-screen__form-reveal"
        :class="{'is-fill': initial && filterOpen || !initial}"
        @click.prevent="handleRevealButton"
    >
            <span v-if="initial && !filterOpen">
                Getränk auswählen
            </span>
      <template v-else>
        Auswahl
        <span v-if="openForm && filterOpen">schließen</span>
        <span v-else>anzeigen</span>
      </template>
    </button>
  </form>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import MultiSelect from "./partials/MultiSelect";
import MultiSelectProduct from "./partials/MultiSelectProduct";
import ButtonSelect from "./partials/ButtonSelect";
import Spinner from "./partials/Spinner";
import SingleSelect from "./partials/SingleSelect";

export default {
  name: "Form",
  components: {SingleSelect, Spinner, ButtonSelect, MultiSelect, MultiSelectProduct},
  props: {
    defaultQuery: String,
    initial: Boolean,
    initGeo: Boolean,
    defaultProduct: Number,
    loading: Boolean
  },
  watch: {
    initial: 'handleInitialChange',
    categoryList: 'applyCategorySelect'
  },
  data() {
    return {
      filter: {
        min: 5,
        max: 50,
        steps: 5
      },
      form: {
        query: '',
        filter: 5,
        coords: {
          lat: null,
          lon: null
        },
        category: null,
        productGroup: null,
        product: null,
      },
      ready: false
    }
  },
  async mounted() {
    if (this.defaultQuery) {
      this.form.query = this.defaultQuery;
    }
  },
  computed: {
    ...mapState({
      openForm: 'formOpen',
      filterOpen: 'filterOpen',
    }),
    posFinderQuery() {
      const query = {
        distance: parseInt(this.form.filter),
        product: this.form.product,
        productGroup: this.form.productGroup,
        category: this.form.category
      };
      if (this.form.query.length === 0) {
        query.coords = this.form.coords;
      } else {
        query.query = this.form.query;
      }
      return query;
    },
    categoryList() {
      return this.$store.state.categories.filter((category) => {
        const groupsWithProducts = category.product_groups.filter((group) => group.products.length > 0);
        return groupsWithProducts.length > 0;
      });
    },
    productGroupList() {
      return this.categoryList.filter(c => c.id === this.form.category).map(c => c.product_groups).flat().filter(pg => pg.products.length > 0);
    },
    productList() {
      return this.productGroupList.filter(pg => pg.id === this.form.productGroup).filter(pg => pg.products.length > 0).map(pg => pg.products).flat();
    },
  },
  methods: {
    getProductGroupById(id) {
      const productsGroups = this.categoryList.map(c => c.product_groups).flat();
      for (let i = 0; i < productsGroups.length; i++) {
        if (productsGroups[i].id === id) {
          return productsGroups[i];
        }
      }
      return null;
    },
    applyCategorySelect() {
      if (this.ready) {
        return;
      }
      this.categoryList.forEach(c => {
        c.product_groups.forEach(pg => {
          pg.products.forEach(p => {
            if (p.internal_id === this.defaultProduct) {
              this.form.category = c.id;
              this.form.productGroup = pg.id;
              this.form.product = p.id
            }
          })
        });
      })
      if (this.initGeo) {
        this.startGeo();
      } else {
        this.startSearch();
      }
      this.ready = true;
    },
    handleInitialChange() {
      this.$store.commit('setFilterOpenState', !this.initial);
    },
    handleRevealButton() {
      if (this.initial) {
        this.$store.commit('setFilterOpenState', !this.filterOpen);
        return;
      }
      this.$store.commit('setFormOpenState', !this.openForm);
      this.$store.commit('setResultOpenState', false);
    },
    async startGeo() {
      this.$emit('loadStart');
      try {
        const coords = await this.getCoords();
        this.form.coords.lat = coords.coords.latitude;
        this.form.coords.lon = coords.coords.longitude;
      } catch (e) {
        console.error(e);
      }
      this.$emit('loadEnd');
      this.startSearch();
    },
    startSearch(silent, source = null) {
      switch (source){
        case 'category':
          document.getElementsByClassName('posfinder-screen__form-wrapper')[0].scrollTo({ top: 9999, left: 0, behavior: 'smooth'});
          this.form.productGroup = null;
          this.form.product = null;
          break;
        case 'product_group':
          document.getElementsByClassName('posfinder-screen__form-wrapper')[0].scrollTo({ top: 9999, left: 0, behavior: 'smooth'});
          this.form.product = null;
          break;
        default:
          break;
      }

      if (this.form.query.length === 0) {
        if (this.form.coords.lat === null && this.form.coords.lon === null) {
          return;
        }
      }
      this.$emit('startSearch', {
        query: this.posFinderQuery,
        silent
      });
    },
    async getCoords() {
      return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(resolve, e => reject(e.message));
          setTimeout(() => {
            reject("timeout");
          }, 10000);
          return;
        }
        reject("not supported");
      });
    }
  }
}
</script>
